import React from 'react'

const Scanned = () => {
  return (
     <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="20" fill="#00A38D" fillOpacity="0.1"/>
<path d="M16 12H13C12.4477 12 12 12.4477 12 13V16M24 12H27C27.5523 12 28 12.4477 28 13V16M12 24V27C12 27.5523 12.4477 28 13 28H16M28 24V27C28 27.5523 27.5523 28 27 28H24" stroke="#00A38D" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
<line x1="14.625" y1="19.375" x2="26.375" y2="19.375" stroke="#00A38D" strokeWidth="1.25" strokeLinecap="round"/>
</svg>

  )
}

export default Scanned